var React = require('react');

function IconLeadLost (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm0-3.294a8.665 8.665 0 0 0 4.887-1.5L12.22 14.54l-4.84 4.84A8.665 8.665 0 0 0 12 20.707Zm-7.024-3.562L9.9 12.22 4.794 7.113A8.665 8.665 0 0 0 3.294 12c0 1.924.624 3.703 1.682 5.144ZM12.22 9.9 7.113 4.794A8.665 8.665 0 0 1 12 3.294c1.924 0 3.703.624 5.144 1.682L12.22 9.9Zm2.32 2.32 4.84-4.84A8.665 8.665 0 0 1 20.706 12a8.665 8.665 0 0 1-1.5 4.887L14.54 12.22Z"}));
}

IconLeadLost.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = IconLeadLost;

IconLeadLost.default = IconLeadLost;
